import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../../context/ThemeContext'; // Corrected path
import { Sun, Moon } from 'react-feather';
import { Button } from './Button'; // Corrected import

const ToggleButton = styled(Button)`
  /* Styling to make it fit as an icon button */
  padding: ${({ theme }) => theme.spacing(1)};
  background: transparent;
  color: ${({ theme }) => theme.colors.text.secondary};

  &:hover {
    background: ${({ theme }) => theme.colors.background.secondary};
    color: ${({ theme }) => theme.colors.text.primary};
  }
`;

const ThemeToggleButton: React.FC = () => {
  const { themeMode, toggleTheme } = useTheme();

  return (
    <ToggleButton onClick={toggleTheme} aria-label="Toggle theme">
      {themeMode === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
    </ToggleButton>
  );
};

export default ThemeToggleButton; 